import { Select as MantineSelect } from '@mantine/core';
import { ComponentProps } from 'react';

export function Select(props: ComponentProps<typeof MantineSelect>) {
  return <MantineSelect comboboxProps={{ withinPortal: false }} {...props} />;
}
